import React, { useContext } from 'react';
import { CalculatorContext } from '../context/CalculatorContext';
import { Paper, Typography, Grid } from '@mui/material';
import ChartDisplay from './ChartDisplay';

const ResultsDisplay = () => {
  const { results } = useContext(CalculatorContext);

  // If no calculation done yet, show nothing
  if (!results) return null;

  return (
    <Paper sx={{ p: 2, mt: 3 }}>
      <Typography variant="h5" gutterBottom>
        Calculation Results
      </Typography>

      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <Typography gutterBottom>
            <strong>Annual Energy Savings:</strong> {results.coolingLoadReductionKWh} kWh
          </Typography>
          <Typography gutterBottom>
            <strong>Annual Cost Savings:</strong> ₹ {results.annualSavings}
          </Typography>
          <Typography gutterBottom>
            <strong>CO₂ Reduction:</strong> {results.co2ReductionTonnes} tonnes
          </Typography>
        </Grid>

        <Grid item xs={12} md={6}>
          <Typography gutterBottom>
            <strong>Total Application Cost:</strong> ₹ {results.totalApplicationCost}
          </Typography>
          <Typography gutterBottom>
            <strong>Return on Investment (ROI):</strong> {results.roiPercent} %
          </Typography>
          <Typography gutterBottom>
            <strong>Payback Period:</strong> {results.paybackYears} years
          </Typography>
        </Grid>
      </Grid>

      {/* Charts */}
      <ChartDisplay data={results} />
    </Paper>
  );
};

export default ResultsDisplay;
